<div class="p-8">
  <h1 class="text-3xl font-bold text-center mb-10">Nos Structures Gonflables</h1>

  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
    @for (item of chateauList; track item.nom) {
      <div
        (click)="openModal(item)"
        class="card bg-base-100 shadow-xl cursor-pointer hover:scale-105 transition-transform border border-base-200">
        <figure class="px-4 pt-4">
          <img [src]="item.photo" [alt]="item.nom" loading="lazy" class="rounded-xl h-48 w-full object-cover" />
        </figure>
        <div class="card-body items-center text-center">
          <h2 class="card-title text-primary">{{ item.nom }}</h2>
          <div class="card-actions">
            <button class="btn btn-sm btn-outline btn-primary">Voir détails</button>
          </div>
        </div>
      </div>
    }
  </div>

  <dialog id="details_modal" class="modal modal-bottom sm:modal-middle" data-ma-modal>
    @if (selectedChateau) {
      <div class="modal-box">
        <h3 class="font-bold text-2xl text-primary">{{ selectedChateau.nom }}</h3>

        <img [src]="selectedChateau.photo" [alt]="selectedChateau.nom" class="w-full rounded-lg my-4 shadow-md" />

        <div class="space-y-2">
          <p>{{ selectedChateau.description }}</p>
          <p><strong>Dimensions :</strong> <span class="badge badge-ghost">{{ selectedChateau.largeur }}x{{ selectedChateau.longueur }}m</span></p>
          <p class="text-xl font-semibold text-secondary">Prix demi-journée : {{ selectedChateau.prixDemiJournee | number:'1.0-0':'fr' }} F CFP</p>
          <p class="text-xl font-semibold text-secondary">Prix journée : {{ selectedChateau.prixJournee | number:'1.0-0':'fr' }} F CFP</p>
        </div>

        <div class="modal-action">
          <form method="dialog">
            <button class="btn">Fermer</button>
          </form>
          <button class="btn btn-primary" routerLink="/contact">Nous contacter</button>
        </div>
      </div>
    }
    <!-- Clic à côté de la fenêtre : la ferme -->
    <form method="dialog" class="modal-backdrop"><button>Fermer</button></form>
  </dialog>
</div>
